<template>
  <div class="sm-select-modal">
    <div class="sm-select-modal-content">
      <component
        :is="view"
        @change-model="changeModel"
        @back-to-model-list="backToModelList"
      />
    </div>
  </div>
</template>

<script>
import ModelList from "./model-list/model-list";
import ModeSelect from "./mode-select/mode-select";
import Calculations from "./calculations-starter/calculations-starter";
import { getModelChildrenIds } from "@/utils";

export default {
  props: ["map", "base-controller", "editor-controller"],
  components: {
    ModelList,
    ModeSelect,
    Calculations
  },
  computed: {
    view() {
      return this.$store.state.scenarioModelling.view;
    }
  },
  methods: {
    async changeModel({ id, children, name }) {
      const ids = getModelChildrenIds(children);
      this.$store.commit("SET_SM_MODEL", { ids, id, name, children });
      this.$store.commit("SET_SM_STATE_PROP", {
        name: "view",
        value: "mode-select"
      });
      await this.baseController.toggleOn(ids);
      setTimeout(() => this.baseController.flyToModel(id), 100);
      await this.editorController.toggleEditorOn();
    },
    backToModelList() {
      const { ids } = this.$store.state.scenarioModelling.model;
      this.baseController.toggleOff(ids);
      this.editorController.toggleEditorOff();

      this.$store.commit("SET_SM_STATE_PROP", {
        name: "view",
        value: "model-list"
      });
    }
  }
};
</script>

<style lang="scss">
.sm-select-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;

  &-content {
    position: absolute;
    top: 15vh;
    left: 50%;
    transform: translate(-50%);
    border: 1px solid transparent;
    border-radius: var(--border-radius);
    background-color: var(--modal_bg) !important;
    border-color: var(--dividers_low_contrast) !important;
    color: var(--text_secondary) !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 16px;
    height: auto;
    min-width: 320px;
    width: max-content;
  }
}
.light-theme {
  .sm-select-modal-content {
    border: none !important;
  }
}
</style>
